import React from "react";
import { Route, Routes } from "react-router-dom";
import CustomLink from "../components/hoverlink"; // adjust path if needed
import FlipPhoneBlog from "./flip-phone";
import HowNotToRunMarathon from "./how-not-to-run-marathon";
import HowToBeAMillionare from "./how-to-be-a-millionare";
import WebsiteTutorialBlog from "./how-to-code-a-website";
import HowToCreateAResume from "./how-to-create-a-resume";
import EquityResearchJourney from "./how-to-get-a-job";
import AppLaunchBlog from "./how-to-make-an-app";
import Thesis from "./how-to-write-thesis";
import TravelWithCreditCards from "./how-travel-with-credit-card-points";
import PreJackPearsonBlogs from "./pre-jack-pearson-blogs";

export interface BlogPostProps {
  title: string;
  date: string;
  excerpt: string;
  slug: string;
}

// Define the BlogPostItem component
export const BlogPostItem: React.FC<BlogPostProps> = ({
  title,
  date,
  excerpt,
  slug,
}) => (
  <div style={{ marginBottom: "40px" }}>
    <h3 style={{ marginBottom: "10px" }}>{title}</h3>
    <p style={{ marginBottom: "10px", fontStyle: "italic" }}>{date}</p>
    <p>{excerpt}</p>
    <CustomLink href={`/blog/${slug}`}>Read more</CustomLink>
  </div>
);

// Define the BlogList component

// Blogs Edit Tracker

/*
    how-to-write-a-thesis
    how-to-code-a-website
    how-to-make-an-app
    flip-phone
    how-to-get-a-job
    how-to-create-a-resume
    how-travel-with-credit-card-points
    how-not-to-run-marathon ✅
    new-site
    pre-jack-pearson-blogs - Just need to add 1 chart
*/

const BlogList: React.FC = () => (
  <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
    <h2 style={{ marginBottom: "40px" }}>My Blog</h2>

    <BlogPostItem
      title="How to write a thesis"
      date="July 7, 2025"
      excerpt="Tips and lessons I learned from writing my thesis. "
      slug="how-to-write-a-thesis"
    />
    <BlogPostItem
      title="How to code a website"
      date="July 7, 2025"
      excerpt="A tutorial on how I made this website."
      slug="how-to-code-a-website"
    />
    <BlogPostItem
      title="How to get an app on the App Store"
      date="July 6, 2025"
      excerpt="My experience building and launching Forevergreen."
      slug="how-to-make-an-app"
    />
    <BlogPostItem
      title="I had a flip phone for 5 months in college"
      date="July 5, 2025"
      excerpt="Why I got a flip phone and my experience."
      slug="flip-phone"
    />
    <BlogPostItem
      title="How I landed a job on Wall Street at 19"
      date="June 25, 2025"
      excerpt="How I landed a six figure job on Wall Street. Networking, interviews, and more."
      slug="how-to-get-a-job"
    />
    <BlogPostItem
      title="How to create a resume to land your dream job"
      date="June 13, 2025"
      excerpt="How I built the resume that landed me a six figure job on Wall Street."
      slug="how-to-create-a-resume"
    />
    <BlogPostItem
      title="How I used credit cards to backpack to 5 countries"
      date="June 12, 2025"
      excerpt="I got to 5 countries and only spent $28 on flights."
      slug="how-travel-with-credit-card-points"
    />
    <BlogPostItem
      title="How not to train for and run a marathon"
      date="June 11, 2025"
      excerpt="I ran my first ever marathon and it hurt. Heres what I wish I knew. "
      slug="how-not-to-run-marathon"
    />
    <BlogPostItem
      title="New Personal Website!"
      date="September 20, 2024"
      excerpt="I made a new website! This is my 5th blog post. I hope you enjoy it."
      slug="new-site"
    />
    <BlogPostItem
      title="My Coding Orgins"
      date="December 5, 2023 - January 14, 2024"
      excerpt="These are all the blogs I wrote before I made this website."
      slug="pre-jack-pearson-blogs"
    />
  </div>
);

// Define the main Blog component with routes
const Blog: React.FC = () => (
  <Routes>
    <Route path="/" element={<BlogList />} />
    <Route path="/pre-jack-pearson-blogs" element={<PreJackPearsonBlogs />} />
    <Route path="/how-not-to-run-marathon" element={<HowNotToRunMarathon />} />
    <Route path="/how-to-be-a-millionare" element={<HowToBeAMillionare />} />
    <Route
      path="/how-travel-with-credit-card-points"
      element={<TravelWithCreditCards />}
    />
    <Route path="/how-to-create-a-resume" element={<HowToCreateAResume />} />
    <Route path="/how-to-get-a-job" element={<EquityResearchJourney />} />
    <Route path="/flip-phone" element={<FlipPhoneBlog />} />
    <Route path="/how-to-make-an-app" element={<AppLaunchBlog />} />
    <Route path="/how-to-code-a-website" element={<WebsiteTutorialBlog />} />
    <Route path="/how-to-write-a-thesis" element={<Thesis />} />
  </Routes>
);

export default Blog;
